import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="reports-filter"
export default class extends Controller {
  connect() {
    console.log("ReportsFilter controller connected");
  }

  applyFilter(event) {
    // Get the selected date range from the clicked button
    const dateRange = event.currentTarget.dataset.filterDateRange || "";
    const filterby = event.currentTarget.dataset.filterFilterBy || "";

    // Get the target path from the closest element with data-reports-filter-target-path
    const targetPath = this.element.closest('[data-reports-filter-target-path]')?.dataset.reportsFilterTargetPath;

    // Fallback to a default path if none is provided (optional)
    const defaultPath = "/admin/reports/dashboard";
    const baseUrl = targetPath || defaultPath;

    // Construct the URL with the selected date range
    const url = new URL(window.location.origin + baseUrl);
    console.log(`Applying filter: ${dateRange}`);
    console.log(`Target URL: ${url}`);
    url.searchParams.set("date_range", dateRange);
    url.searchParams.set("filter_by", filterby);

    // Send the GET request
    fetch(url, {
      method: "GET",
      headers: {
        "X-Requested-With": "XMLHttpRequest", // Enables Rails UJS support for Turbo
      },
    })
      .then((response) => {
        if (response.ok) {
          // Update the page or let Turbo Stream handle the UI update
          return response.text();
        } else {
          throw new Error("Request failed");
        }
      })
      .then((html) => {
        // Optional: Handle the response and update the DOM manually if necessary
        document.body.innerHTML = html; // Replace the body with the response (adjust as needed)
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  }
}
